import * as React from 'react'
import { Link } from 'react-router-dom'
import { Line, FooterWrap, LinkWrapper } from './FooterStyle'

export default class Footer extends React.Component {
  render() {
    const year = new Date().getFullYear()

    return (
      <FooterWrap>
        <LinkWrapper>
          <Link to='/zahlungsmoeglichkeiten' target='_blank'>
            Zahlungsmöglichkeiten
          </Link>
          <Link to='/agb' target='_blank'>
            AGB
          </Link>
          <Link to='/datenschutz' target='_blank'>
            Datenschutz
          </Link>
          <Link to='/impressum' target='_blank'>
            Impressum
          </Link>
        </LinkWrapper>
        <Line>&copy;{year} Benu GmbH. Alle Rechte vorbehalten.</Line>
      </FooterWrap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/Footer.tsx